import { Component, Input, OnInit, SimpleChanges, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material';
import { Router } from '@angular/router';
import { DocumentService } from '../../services/document.service';
import { saveAs } from "file-saver";
import { FilterService } from 'src/app/services/filter.service';
import { PortfolioService } from '../../services/portfolio/portfolio.service';
import { CourseUnitsService } from '../../services/course-units.service';
import { DownloadService } from '../../services/download.service'
import { UtilityService } from '../../services/utility.service';

@Component({
  selector: 'app-learner-profile-list',
  templateUrl: './learner-profile-list.component.html',
  styleUrls: ['./learner-profile-list.component.scss']
})
export class LearnerProfileListComponent implements OnInit {

  @Input('learners') learnersList;
  @Input('units') unitList;
  @Input('job') job;
  @Input('isIQA') Iqa

  displayedColumns = []

  pageSizeOptions: number[] = [25, 50, 100];
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  lernerForms = []

  noDataMsg = {
    title: "No Data!",
    data: "You have not yet added any records"
  }

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  headers: any[];
  loading: boolean = false;
  headersCopy: any;
  afterFilter: any;
  filterActive: boolean;
  lernerFormsCopy: any;
  user
  courseId
  isIQA: boolean = false;
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  constructor(
    private router: Router,
    public documentService: DocumentService,
    public _filter: FilterService,
    public _portfolioService: PortfolioService,
    public unitService: CourseUnitsService,
    public _utilityServices: UtilityService,
    public _downloadService: DownloadService
  ) {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
  }

  ngOnChanges(change?: SimpleChanges) {
    console.log("changes of units array in learner profile", change)
    if (change.Iqa && change.Iqa.currentValue) {
      console.log("change...", change.Iqa);
      this.isIQA = change.Iqa.currentValue;
    }
    if (change.job && change.job.currentValue) {
      this.job = change.job.currentValue
      let objLength = Object.keys(this.job)
      if (objLength && objLength.length && this.job && (this.job.course || this.job.course.type)) {
        console.log("current job value in list form =======", this.job);
        this.courseId = this.job.course._id
        this.displayedColumns = []
        this.displayedColumns = [{ title: 'Learner' }, { title: 'Medical Needs' }, { title: 'Barriers to Learning Including English as a Second Language' },
        { title: 'BKSB Diagnostic English' }, { title: 'BKSB Diagnostic Maths' }, { title: 'Teaching Strategies / Observations' }]
        this.headers = this.displayedColumns.map(col => col.title);
        this.headersCopy = this.displayedColumns.map(col => col.title);
      }
      if (this.job && this.job._id) {
        this.getListOfLpForms()
      }
    }

    if (change && change.unitList) {
      // console.log()
      let objLength = Object.keys(this.job)
      if (objLength && objLength.length && this.job.course.type != 'Level2' && change.unitList.currentValue.length) {
        this.unitList = change.unitList.currentValue
        this.displayedColumns = []
        if (this.unitList && this.unitList.length) {
          this.unitList.forEach(unit => {
            this.displayedColumns.push({ title: 'Unit-' + unit.unitNo + " " + unit.title, id: unit._id })
          })
          this.displayedColumns.push({ title: 'PTS' }, { title: 'Destination Data' }, { title: 'Action' })
          // console.log("array after units added", this.displayedColumns)
          this.headers = this.displayedColumns.map(col => col.title);
          this.headersCopy = this.displayedColumns.map(col => col.title);
          // this.changeDetector.detectChanges()
        }
      }
      if (objLength && objLength.length && this.job.course.type == 'Level2') {
        // console.log("this is for level 2 jobs", ' ');
        this.getLevel2Units()
      }
    }
  }

  addRecord() {
    this.router.navigate(['/jobDoc/learner-profile/'], { queryParams: { jobId: this.job._id, courseId: this.job.course._id, type: this.job.course.type } })
  }

  redirect(learnerId) {
    this.router.navigate(['/jobDoc/learner-profile/'], { queryParams: { learnerId: learnerId, jobId: this.job._id, courseId: this.job.course._id, type: this.job.course.type } })
  }



  // UTILITY
  updateData(jobs) {
    console.log('UPDATING DATA = ', jobs)
    this.dataSource = new MatTableDataSource(jobs);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("item", item, "property", property);
      switch (property) {
        case 'Learner': return item.learnerId.name;
        case 'Medical Needs': return item.details.leanerForm.medicalNeed;
        case 'Barriers to Learning Including English as a Second Language': return item.details.leanerForm.barriers;
        case 'BKSB Diagnostic English': return item.details.leanerForm.bksbEnglish;
        case 'BKSB Diagnostic Maths': return item.details.leanerForm.bksbMaths;
        case 'Teaching Strategies / Observations': return item.details.leanerForm.teaching;
        case 'PTS': return item.details.leanerForm.pts;
        case 'Destination Data': return item.details.leanerForm.destinationData;
        case property: return this.sortUnits(property);
        // if (item.course)
        // return item.course.title;
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;
    console.log('SETTING SORT TO = ', this.dataSource.sort)
    console.log('SETTING paginator TO = ', this.dataSource.paginator)
  }


  sortUnits(property) {
    console.log("what is the property when it is click on units", property);
    console.log("what is the units=========", this.unitList);

    let data = this.unitList.sort((a, b) => a.unitNo - b.unitNo)
    console.log("data after sorting", data);
    return data



  }

  openedChange(event) {
    console.log("open changed event", event)
  }

  headersChanged(event) {
    console.log("selection changed event", event)
    if (event.value && event.value.length) {
      this.headers = ['Learner']
      this.headers.push(...event.value)
    } else {
      this.headers = this.headersCopy
    }
  }

  applyFilter(searchText) {
    this.afterFilter = null
    this.filterActive = true;
    if (searchText === '') {
      this.updateData(this.lernerForms);
      this.filterActive = false;
    }

    console.log('this.lernerForms', this.lernerForms)
    let sortedList = this.lernerForms.filter(function (a) {
      console.log("a", a, "a.learnerId.includes(searchText)", a.learnerId.name.toLowerCase().includes(searchText.toLowerCase()))
      return a.learnerId.name.toLowerCase().includes(searchText.toLowerCase())
    })
    console.log("sortedList", sortedList)
    // this.lernerForms = sortedList
    this.updateData(sortedList)
    // let filteredLearner = this._filter.filter(searchText, this.lernerForms, ['name']);
    // console.log("filteredLearner",filteredLearner)
    // this.updateData(filteredLearner);
    if (sortedList.length <= 0) {
      this.afterFilter = {
        title: "No Learners!",
        data: "No learners with matched search text found!"
      }
    }
  }

  download() {
    let Obj = {
      csvType: 'learnerProfileList',
      lernerForms: this.lernerForms,
      headers: this.headers,

    }
    this._downloadService.downloadCSV(Obj).subscribe((csvResponse) => {
      this.loading = false
      const downloadLink = document.createElement("a");
      if (csvResponse && csvResponse.data) {
        this._utilityServices.handleSnackBar({ msg: "CSV download Successfully!", button: "Ok" })
        downloadLink.href = csvResponse.data;
        downloadLink.click();
      }
    }, (error) => {
      this.loading = false
      this._utilityServices.handleSnackBar({ msg: "CSV download Fail!", button: "Ok" })
      console.log("SOME error occure ===>", error)
    })
  }






  // API Call


  getListOfLpForms() {
    this.loading = true
    console.log("CURRENT JOB DATA,", this.job)
    this.documentService.getLpDocuments(this.job._id).subscribe((response) => {
      console.log("response of learners list with form details", response);
      this.loading = false
      if (response && response.length) {
        this.lernerForms = response
        this.lernerFormsCopy = response
      } else {
        this.lernerForms = []
        this.lernerFormsCopy = []
      }
      this.updateData(this.lernerForms)
    }, error => {
      console.log("error while get lp form list", error);
      this.loading = false
    })
  }

  getLevel2Units() {
    // this._portfolioService.getClassromGroupedByCourseId(this.courseId).subscribe(res => {
    this.unitList = []
    //   this.displayedColumns = []
    //   this.loading = false
    //   console.log('classroom grouped portfolio', res);
    //   if (res && res.length) {
    //     let assignment = res
    //     assignment.forEach((item) => {
    //       console.log("single item", item);
    //       item.session.forEach((singleAssign) => {
    //         let obj = {
    //           _id: singleAssign.sessionId,
    //           unitTitle: item._id + ": Unit-" + singleAssign.sessionUnit
    //         }
    //         let index = this.unitList.findIndex(function (o) { return o._id == singleAssign.sessionId })
    //         console.log("index of this element", index);
    //         if (index == -1) {
    //           this.unitList.push(obj)
    //         }
    //       })
    //     })

    //     this.displayedColumns = [{ title: 'Learner' }, { title: 'Medical Needs' }, { title: 'Barriers to Learning Including English as a Second Language' },
    //     { title: 'BKSB Diagnostic English' }, { title: 'BKSB Diagnostic Maths' }, { title: 'Teaching Strategies / Observations' }]
    //     console.log("this is the final list to display ", this.unitList);
    //     this.unitList.forEach(unit => {
    //       this.displayedColumns.push({ title: unit.unitTitle, id: unit._id })
    //     })
    //     this.displayedColumns.push({ title: 'PTS' }, { title: 'Destination Data' }, { title: 'Action' })
    //     // console.log("array after units added", this.displayedColumns)
    //     this.headers = this.displayedColumns.map(col => col.title);
    //     this.headersCopy = this.displayedColumns.map(col => col.title);

    //   }
    // })




    this.unitService.getUnits(this.courseId).subscribe(res => {
      console.log("response of all status in main list file", res);
      let unitArray = []
      console.log("display unit array", unitArray);
      // let finalArray = []

      unitArray.forEach((item) => {
        // let obj = {
        //   _id: item.title,
        //   session: []
        // }
        let obj = {
          _id: item._id,
          unitTitle: item.title + ": Unit-" + item.unitNo
        }
        // let index = finalArray.findIndex(x => x._id === item.title);
        let index = this.unitList.findIndex(function (o) { return o._id == item._id })
        console.log("index of this element", index);
        if (index == -1) {
          this.unitList.push(obj)
        }
      })
      this.displayedColumns = [{ title: 'Learner' }, { title: 'Medical Needs' }, { title: 'Barriers to Learning Including English as a Second Language' },
      { title: 'BKSB Diagnostic English' }, { title: 'BKSB Diagnostic Maths' }, { title: 'Teaching Strategies / Observations' }]
      console.log("this is the final list to display ", this.unitList);
      this.unitList.forEach(unit => {
        this.displayedColumns.push({ title: unit.unitTitle, id: unit._id })
      })
      this.displayedColumns.push({ title: 'PTS' }, { title: 'Destination Data' }, { title: 'Action' })
      // console.log("array after units added", this.displayedColumns)
      this.headers = this.displayedColumns.map(col => col.title);
      this.headersCopy = this.displayedColumns.map(col => col.title);
    })


  }

}
